export class ZoneFocusRestorer {
  constructor(zones) {
    this.zones = zones;
  }

  remember = () => {
    this.restoreFocus = this.zones
      .find(({ container }) => container?.contains(document.activeElement))?.focus ?? null;
  };

  restore = () => {
    this.restoreFocus?.();
    this.restoreFocus = null;
  };
}
